import { RowSanctionCheckpointDto } from "@/dtos";
import { SanctionCheckpoint } from "@/entities";

export const formatRowSanctionCheckpoint = (sanctions: SanctionCheckpoint[]): RowSanctionCheckpointDto[] => {
    return sanctions.map((x) => {
        const row: RowSanctionCheckpointDto = {
            id: x.id,
            sanction_name: x.type_sanction.name,
            sanction: x.sanction,
            active: x.is_active ? 'Activo' : 'Inactivo',
            is_active: x.is_active,
            type_sanction: x.type_sanction
        }
        return row;
    });
}